import CardsDefault from "../cardsDefault/cardDefault";

function Sections({ Titulo }) {
  return (
    <div className="Sections py-20">
      <div className="container w-10/12 mx-auto">
        <div className="grid md:grid-cols-3 sm:grid-cols-1 gap-4 pb-4">
          <CardsDefault
            titulo={"Compre"}
            texto={
              'Escolha o tipo de Certificado Digital (e-CNPJ, e-CPF ou NF-e), selecione o tempo de utilização e clique no botão "Comprar Certificado".'
            }
            img={"https://sinpejus.ctplus.com.br/images/ico_comprar1.png"}
          />
          <CardsDefault
            titulo={"Emita"}
            texto={
              "Após a confirmação do pagamento, você pode agendar o atendimento (presencial ou videoconferência), para a emissão do Certificado. Deixe tudo preparado e os documentos organizados."
            }
            img={"https://sinpejus.ctplus.com.br/images/ico_comprar2.png"}
          />
          <CardsDefault
            titulo={"Instale"}
            texto={
              "O protocolo pode ser validado antes de 24 horas ou em até 72 horas. Após a liberação, um e-mail será enviado com as informações sobre a instalação."
            }
            img={"https://sinpejus.ctplus.com.br/images/ico_comprar3.png"}
          />
        </div>
        <div className="columns-1 text-center pt-4">
            <h2 className="text-4xl md:text-6xl  font-bold">{Titulo}</h2>
        </div>
      </div>
    </div>
  );
}

export default Sections;
